<template>
  <b-input-group class="password-input">
    <b-input
      v-bind="$props"
      :type="showing ? 'text' : 'password'"
      @input="input"
    />
    <b-btn @click="showPassword(false)">
      <i :class="`fa fa-eye${showing ? '-slash' : ''}`"></i>
    </b-btn>
  </b-input-group>
</template>

<script>
export default {
  name: 'password-input',
  props: {
    value: {
      type: String,
      default: '',
    },
    id: String,
    name: String,
    autocomplete: String,
    placeholder: String,
    required: Boolean,
  },
  data() {
    return {
      showing: false,
    };
  },
  methods: {
    input(event) {
      this.$emit('input', event);
    },
    showPassword(background) {
      if (background && !this.showing) {
        return; // prevent a background change if user click stopped showing
      }
      this.showing = !this.showing;
      if (this.showing && !background) {
        setTimeout(() => this.showPassword(true), 1000);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utility/PasswordInput.vue